var React = require('react');

function Css (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.192,3.143h15.615l-1.42,16.034l-6.404,1.812l-6.369-1.813L4.192,3.143z M16.9,6.424L7.1,6.422l0.158,1.949l7.529,0.002\tl-0.189,2.02H9.66l0.179,1.913h4.597l-0.272,2.62l-2.164,0.598l-2.197-0.603l-0.141-1.569h-1.94l0.216,2.867L12,17.484l3.995-1.137\tL16.9,6.424L16.9,6.424z"}));
}

Css.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 24 24"};

module.exports = Css;

Css.default = Css;
